import { useSetStatusHook } from '@/features/set-status'

import { useStoreSettingsNotifications } from '@/entities/notification'


const RETRY_INTERVAL_MS = 5_000
const MAX_ATTEMPTS = 24

let retryTimer: ReturnType<typeof setInterval> | null = null
let attempts = 0
let getActiveSessionsCount: (() => number) | null = null

export const stopCallStatusRestoreRetry = () => {
  if (retryTimer) {
    clearInterval(retryTimer)
    retryTimer = null
  }
  attempts = 0
  getActiveSessionsCount = null
}

export const attemptCallStatusRestore = (activeSessionsCount: number): Promise<boolean> => {
  const { callStatusDoNotDisturb, resetCallStatusIfChangedByCall } = useStoreSettingsNotifications()
  const { setUpdateDNDonSetStatus } = useSetStatusHook()

  if (!callStatusDoNotDisturb.isChangedByCall) {
    stopCallStatusRestoreRetry()
    return Promise.resolve(true)
  }

  if (activeSessionsCount > 0) {
    return Promise.resolve(false)
  }

  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return Promise.resolve(false)
  }

  const oldStatusNumber = callStatusDoNotDisturb.oldStatusNumber

  return resetCallStatusIfChangedByCall().then((isSuccess) => {
    if (isSuccess) {
      setUpdateDNDonSetStatus(oldStatusNumber)
      stopCallStatusRestoreRetry()
    }
    return isSuccess
  })
}

export const scheduleCallStatusRestoreRetry = (getSessionsCount: () => number) => {
  if (retryTimer) return

  getActiveSessionsCount = getSessionsCount
  attempts = 0
  retryTimer = setInterval(() => {
    attempts += 1
    const sessionsCount = getActiveSessionsCount?.() ?? 0
    attemptCallStatusRestore(sessionsCount).then((isSuccess) => {
      if (isSuccess || attempts >= MAX_ATTEMPTS) {
        stopCallStatusRestoreRetry()
      }
    })
  }, RETRY_INTERVAL_MS)
}
